/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { CHALLENGE_ISSUE_NOTE_MAX_LENGTH, challengeIssueDetailSchema } from '../enums';

export const reportChallengeIssueRequestSchema = z.object({
  challengeId: z.number().int(),
  details: z.array(challengeIssueDetailSchema).min(1),
  note: z.string().max(CHALLENGE_ISSUE_NOTE_MAX_LENGTH).optional(),
  lang: z.string().nullable().optional(),
  // URL of the clip the reporter was watching, so a video report targets that single clip.
  clipUrl: z.string().url().optional(),
});

export type IReportChallengeIssueRequest = z.infer<typeof reportChallengeIssueRequestSchema>;
